import React from "react";
import ReactDOM from "react-dom/client";
import { logger } from "./lib/logger";
import { ErrorCodes } from "./lib/errorCodes";

window.addEventListener("unhandledrejection", (event) => {
  logger.error("unknown", ErrorCodes.UNKNOWN_001, "Unhandled promise rejection", event.reason);
});

window.addEventListener("error", (event) => {
  logger.error("unknown", ErrorCodes.UNKNOWN_001, event.message, event.error);
});
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./state/store";
import { ThemeProvider } from "@emotion/react";
import { ConnectionProvider } from "./context/connectionContext";
import { createTheme } from "@mui/material";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      // main: '#1976d2',
      // main: '#ff5252', // Customize primary color
      main: "#F9B958", // Customize primary color
    },
    secondary: {
      main: "#69f0ae", // Customize secondary color
    },
    background: {
      default: "#121212", // Customize background color
      paper: "#1e1e1e", // Customize paper color
    },
    text: {
      primary: "#ffffff", // Customize primary text color
      secondary: "rgba(255, 255, 255, 0.7)", // Customize secondary text color
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "50px", // Adjust this value to control the roundness
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={darkTheme}>
        <ConnectionProvider>
          <App />
        </ConnectionProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
